<template lang="pug">
div.field
  .control
    .select
      select(v-model="selected")
        option(v-for="c of crews", :value="c") {{c.name}}

</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CrewPicker",

  computed: {
    ...mapState(["crew", "crews"]),
    selected: {
      get() {
        return this.$store.state.crew;
      },
      set(value) {
        this.$store.commit("crew", value);
      }
    }
  },
  props: {}
};
</script>

<style scoped lang="less">
</style>